import React from 'react';
import './TextField.css';

/*
  Shared text input (IMP-037).
  error: show the error state and errorMessage below the input
  className: page-specific layout (e.g. spacing) only
*/
export default function TextField({
    label,
    name,
    id,
    type = "text",
    error = false,
    errorMessage,
    className = "",
    ...inputProps
}) {
    const generatedId = React.useId();
    const inputId = id || (name ? `field-${name}` : generatedId);
    const errorId = `${inputId}-error`;

    return (
        <div className={`TextField ${className}`.trim()}>
            <label className="TextField--label" htmlFor={inputId}>{label}</label>
            <input
                id={inputId}
                name={name}
                type={type}
                className={`TextField--input${error ? " is-error" : ""}`}
                aria-invalid={error || undefined}
                aria-describedby={error ? errorId : undefined}
                {...inputProps}
            />
            {error && <p className="TextField--error" id={errorId}>{errorMessage}</p>}
        </div>
    );
}
